import { useState } from 'react';
import { ArrowDown, ArrowUp, GripVertical } from 'lucide-react';
import { Switch } from '../../ui/switch';

// Reorderable on/off list for Customize Dashboard: native drag-and-drop + arrow buttons.
export function SectionOrderList({ order, labels, isOn, onToggle, onReorder }) {
  const [dragKey, setDragKey] = useState(null);
  const move = (from, to) => {
    if (to < 0 || to >= order.length || from === to) return;
    const next = [...order];
    const [k] = next.splice(from, 1);
    next.splice(to, 0, k);
    onReorder(next);
  };
  return (
    <div className="space-y-2" data-testid="dashboard-section-order">
      {order.map((key, i) => (
        <div key={key} draggable
          onDragStart={() => setDragKey(key)}
          onDragOver={(e) => { e.preventDefault(); if (dragKey && dragKey !== key) move(order.indexOf(dragKey), i); }}
          onDragEnd={() => setDragKey(null)}
          className={`flex items-center gap-2 p-2.5 rounded-lg border bg-card text-card-foreground ${dragKey === key ? 'border-blue-400 opacity-60' : 'border-border hover:bg-muted'}`}
          data-testid={`dashboard-section-${key}`}>
          <GripVertical className="h-4 w-4 text-muted-foreground cursor-grab shrink-0" />
          <span className="text-sm flex-1">{labels[key]}</span>
          <button type="button" onClick={() => move(i, i - 1)} disabled={i === 0} aria-label="Move up"
            className="p-1 rounded hover:bg-muted disabled:opacity-30" data-testid={`dashboard-section-up-${key}`}>
            <ArrowUp className="h-4 w-4" />
          </button>
          <button type="button" onClick={() => move(i, i + 1)} disabled={i === order.length - 1} aria-label="Move down"
            className="p-1 rounded hover:bg-muted disabled:opacity-30" data-testid={`dashboard-section-down-${key}`}>
            <ArrowDown className="h-4 w-4" />
          </button>
          <Switch checked={isOn(key)} onCheckedChange={() => onToggle(key)} data-testid={`dashboard-section-toggle-${key}`} />
        </div>
      ))}
    </div>
  );
}

export default SectionOrderList;
